import { LinkSocialIdentityPayload } from './link-social-identity-result';

export interface UnLinkSocialIdentityResult {
  unlinkUserIndentity: LinkSocialIdentityPayload;
}
